import { useEffect, useRef, useState } from 'react';
import "react-datepicker/dist/react-datepicker.css";
import Loader from '../Layout/Loader';
import { GetDate,BindGrid, BindReportGrid, BindReportGridWithCheckBox, exportToExcel, setFocus, setTitle } from '../Common/Common';
import { Cookies } from 'react-cookie';
import { API_SERVER } from '../../EnvConfig/env_config';
import { post } from '../Common/service';
import { AlertBox, AutoCompleteBox, DateBox } from '../Common/Input';
import { getCommonData } from '../Common/CommanServices';
import { useNavigate } from "react-router-dom";
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

const SAPIntegrationReport = ({ open, setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const inputrefs = useRef([]);
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [MenuText, setMenuText] = useState("SAPIntegrationReport");
    const [showInvoiceModal, setShowInvoiceModal] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(1);
    
    const [tableData, setTableData] = useState({})
    const [invoiceTable, setInvoiceTable] = useState({});
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })

    const [SaveData, setSaveData] = useState({
        SAPIntegrationReportID: "0",
        processType: "",
        status: "",
        fromDate: GetDate(-10),
        toDate: GetDate(0)
    });

    const [statusDropDown, setStatusDropDown] = useState([]);
    const [processTypeDropDown, setProcessTypeDropDown] = useState([]);

    //Status DropDown
    const getStatusDropDown = async () => {
        let Condition = "";
        let Type = "GetStatus";
        let ContextKey = "";
        let ContextKey2 = "";
        let ContextKey3 = "";
        let ContextKey4 = "";

        const loginCodeString = String(LoginUserCode);

        let data = {
            Token,
            LoginUserCode: loginCodeString,
            Type,
            Condition,
            ContextKey,
            ContextKey2,
            ContextKey3,
            ContextKey4
        };

        post(`${API_SERVER}/api/AutoComplete/GetDropDownData`, data, (res) => {
            if (res.status === "SUCCESS") {
                setStatusDropDown(res.dataList);
            } else if (res.message === "EXPIRED") {
                navigate('/Login');
            } else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
        });
    };
    //ProcessType DropDown
    const getProcessTypeDropDown = async () => {
        let Condition = "";
        let Type = "GetPushAPIEndPoint";
        let ContextKey = "";
        let ContextKey2 = "";
        let ContextKey3 = "";
        let ContextKey4 = "";

        const loginCodeString = String(LoginUserCode);

        let data = {
            Token,
            LoginUserCode: loginCodeString,
            Type,
            Condition,
            ContextKey,
            ContextKey2,
            ContextKey3,
            ContextKey4
        };

        post(`${API_SERVER}/api/AutoComplete/GetDropDownData`, data, (res) => {
            if (res.status === "SUCCESS") {
                setProcessTypeDropDown(res.dataList);
            } else if (res.message === "EXPIRED") {
                navigate('/Login');
            } else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
        });
    };

    const handleClear = async () => {
        setSaveData({
            SAPIntegrationReportID: "0",
            processType: "",
            status: "",
               fromDate: GetDate(-10),
        toDate: GetDate(0)

        });
        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setIsUpdate(!isUpdate)
    }

    useEffect(() => {
        setTitle('SAPIntegrationReport', setOpen);
        setFocus('txtCountry');
        getStatusDropDown();
        getProcessTypeDropDown();
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);

    //useEffect(() => {
    //    GetIntegrationLogReport();
    //}, [filterData.PageIndex, isUpdate]);


    // HANDLE SUBMIT AFTER CHECK
    const handleSubmit = async () => {
        const loginCodeString = String(LoginUserCode);
        
        const selectedRefs = tableData?.Data
            ?.filter(item => item.checkStatus)
            ?.map(item => item.CheckBox)
            ?.join(',');

        if (!selectedRefs) {
            AlertBox("WARNING", "Please select at least one record");
            return;
        }

        setIsLoading(true);

        let data = {
            ...SaveData,
            RefNo: selectedRefs,  
            Token,
            LoginUserCode: loginCodeString
        };

        post(`${API_SERVER}/api/Dashboard/UpdateRePushSap`, data, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus);
              
                GetIntegrationLogReport("S","1");
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login');
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus);
            }
            setIsLoading(false);
        });
    };

   
    //GET INTEGRATION LOG REPORT
    const GetIntegrationLogReport = async (Type = 'S', PI = filterData?.PageIndex || "1") => {
        const loginCodeString = String(LoginUserCode);

        const data = {
            ...SaveData,
            ...filterData,
            Type,
            Token,
            LoginUserCode: loginCodeString,
            PageIndex: `${PI}`
        };
        setIsLoading(true);
        post(`${API_SERVER}/api/Dashboard/GetIntegrationLogReport`, data, (res) => {

          
            const status = res.status || res.Status;
            const message = res.message || res.Message;
            const focus = res.focus || res.Focus;

            if (status === 'SUCCESS') {
                if (Type === 'S') {
                    const updatedData = res.Data.map(item => ({
                        ...item,
                        checkStatus: false   // default unchecked
                    }));

                    setTableData({
                        ...res,
                        Data: updatedData
                    });
                    //console.log(tableData);
                }
                else {
                    if (Array.isArray(res.Data)) {
                        exportToExcel(res.Data, 'SAP_Integration_Report');
                    }
                }
            }
            else if (status === 'EXPIRED') {
                navigate('/Login');
            }
            else if (message !== "") {
                AlertBox(status, message, focus);
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]
                    })
            }
            setIsLoading(false)
        });
    };



    
    //HANDLE CHECK
    const handleCheck = (checked, item, index) => {
        setTableData(prev => {
            const newData = prev.Data.map((row, i) =>
                i === index ? { ...row, checkStatus: checked } : row
            );
            return { ...prev, Data: newData };
        });

    };

    //HANDLE CHANGE
    const handleAllchange = (e) => {
        const { checked } = e.target;
        
        setTableData(prev => {
            const newData = prev.Data.map(row => ({ ...row, checkStatus: checked }));
            return { ...prev, Data: newData };
        });
    };

    const handleChange1 = (event, value) => {
        GetIntegrationLogReport("S", value);
    };


    //HANDLE GET INVOICE NO DETAIL
    const GetInvoiceDetails = async (invoiceNo) => {
        const loginCodeString = String(LoginUserCode);

        const data = {
            InvoiceNo: invoiceNo,
            ...filterData,
            PageIndex:"1",
            Type: "S",
            processType: SaveData.processType,
            Token,
            LoginUserCode: loginCodeString
        };

        setIsLoading(true);

        post(`${API_SERVER}/api/Dashboard/GetInvoicedetails`, data, (res) => {
            setIsLoading(false);

            const status = res.status || res.Status;
            const message = res.message || res.Message;

            if (status === 'SUCCESS') {
                setInvoiceTable(res);   // correct
            }
            else if (status === 'EXPIRED') {
                navigate('/Login');
            }
            else if (message !== "") {
                AlertBox(status, message);
                setInvoiceTable({
                    TotalRecord: 0,
                    Data: []
                });
            }
        });
    };

    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        GetIntegrationLogReport('S',1);
    }
    const handleDownloadExcel = async () => {
        GetIntegrationLogReport('E');
    }

    const isAnyChecked = tableData?.Data?.some(item => item.checkStatus === true);
   
    
    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Status<span className="Required">*</span></label>
                                            <select
                                                id="txtStatus"
                                                className="form-select"
                                                value={SaveData.status}
                                                onChange={(e) => setSaveData({ ...SaveData, status: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus("txtProcessType")
                                                    };

                                                }}
                                            >
                                                <option>--Select Status--</option>
                                                {
                                                    statusDropDown.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.code}>{item.name}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Process Type<span className="Required">*</span></label>
                                            <select
                                                id="txtProcessType"
                                                className="form-select"
                                                value={SaveData.processType}
                                                onChange={(e) => setSaveData({ ...SaveData, processType: e.target.value })}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus("txtInvoiceFromDate")
                                                    };

                                                }}
                                            >
                                                <option>--Select Process Type--</option>
                                                {
                                                    processTypeDropDown?.map((item, index) => {
                                                        return (
                                                            <option key={index} value={item.code}>{item.name}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <DateBox
                                                id='txtInvoiceFromDate'
                                                inputrefs={inputrefs}
                                              
                                                label='From Date'
                                                placeholder="From Date"
                                                required={false}
                                                selected={SaveData.fromDate === '' ? '' : new Date(SaveData.fromDate)}
                                                onChange={(e) => {
                                                    let dateArr = e?.toString()?.split(' ')
                                                    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`
                                                    setSaveData({ ...SaveData, fromDate: dateArr })
                                                }}
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtInvoicetoDate") };
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="fields">
                                            <DateBox
                                                id='txtInvoicetoDate'
                                                inputrefs={inputrefs}
                                               
                                                label='To Date'
                                                placeholder="To Date"

                                                selected={SaveData.toDate === '' ? '' : new Date(SaveData.toDate)}
                                                onChange={(e) => {
                                                    let dateArr = e?.toString()?.split(' ')
                                                    dateArr = `${dateArr[2]}-${dateArr[1]}-${dateArr[3]}`
                                                    setSaveData({ ...SaveData, toDate: dateArr })
                                                }}
                                                maxDate={new Date()}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtSalesPerson") };
                                                }}
                                            />
                                        </div>
                                    </div>

                                    
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.SAPIntegrationReportID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                    <i className="bi bi-check-lg" /> Update For Re-Push
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                                </button> : <button className="button save-btn" id='btnSave' onClick={searchHandle}>
                                                <i className="bi bi-check-lg" /> Search
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                            {isAnyChecked && (
                                                <button
                                                    className="button save-btn"
                                                    style={{ marginLeft: "10px" }}
                                                    onClick={handleSubmit}
                                                >
                                                    <i className="bi bi-check-lg" /> Update For Re-Push
                                                </button>
                                            )}

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindReportGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} currentPageNo={1} handleChange1={handleChange1} handleCheckboxChange={handleCheck}
                handleAllchange={handleAllchange} clickableColumn="RefNo"
                setShowInvoiceModal={setShowInvoiceModal}
                onColumnClick={GetInvoiceDetails} />
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
            {console.log(tableData)}


            <Dialog
                open={showInvoiceModal}
                onClose={() => setShowInvoiceModal(false)}
                aria-labelledby="alert-dialog-title"
                maxWidth="lg"
                fullWidth
                aria-describedby="alert-dialog-description"
                sx={{
                    "& .MuiDialog-container": {
                        "& .MuiPaper-root": {
                            width: "200%",
                            maxWidth: "1000px",
                        }
                    },
                    "& .css-hz1bth-MuiDialog-container": {
                        alignItems: 'start'
                    }
                }}
            >
                <DialogTitle id="alert-dialog-title" className='py-1 px-2 border-bottom d-flex justify-content-between'>
                    <h6 className='py-1 my-1'>Details</h6>

                    <div style={{ fontWeight: 500, cursor: 'pointer' }} title='close'>
                        <i className='fa-solid fa-xmark' onClick={() => setShowInvoiceModal(false)} />
                    </div>
                </DialogTitle>
                <DialogContent className='main-card px-2 mx-0 my-0 py-2' style={{ boxShadow: 'none' }}>
                    <BindReportGrid tableData={invoiceTable} setFilterData={setFilterData} filterData={filterData} currentPageNo={currentPageNo} handleChange1={handleChange1} />
                </DialogContent>
            </Dialog>
        </main>
    )
}
export default SAPIntegrationReport;